import imageCompression from "browser-image-compression";

//預設：大頭貼 ~256KB / 512px、文章圖 ~1MB / 1920px
//  initialQuality 控制 JPEG 壓縮品質、maxSizeMB 是 lib 內部的二分搜尋目標上限
//  fileType 留空 → 跟原檔同格式（PNG 留 PNG、JPEG 留 JPEG）；瀏覽器 webp/HEIC 通常會自動轉 jpeg
export const PRESETS = {
  avatar: {
    maxSizeMB: 0.3,
    maxWidthOrHeight: 512,
    initialQuality: 0.8,
    useWebWorker: true,
  },
  article: {
    maxSizeMB: 1,
    maxWidthOrHeight: 1920,
    initialQuality: 0.85,
    useWebWorker: true,
  },
};

//把 File 壓成符合 preset 的新 File。
//  非圖片 / 壓縮失敗時直接回原檔，不卡使用者流程
export const compressImage = async (file, preset = "avatar") => {
  if (!file || !file.type?.startsWith("image/")) return file;
  //GIF 動圖不壓（lib 會壓成單張），SVG 也不適合
  if (/gif|svg/i.test(file.type)) return file;

  try {
    const options = PRESETS[preset] || PRESETS.avatar;
    return await imageCompression(file, options);
  } catch (e) {
    console.warn("[image-compress] 壓縮失敗，改傳原檔:", e?.message);
    return file;
  }
};
